import CommunityNotification from './CommunityNotification'

export default CommunityNotification
// eslint-disable-next-line import/export
export * from './CommunityNotification'
